import { render, staticRenderFns } from "./PendingCollegeUpdateRequest.vue?vue&type=template&id=60e05ac2"
import script from "./PendingCollegeUpdateRequest.vue?vue&type=script&lang=js"
export * from "./PendingCollegeUpdateRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports